module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "title-frontMatter"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429936354_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Prologue")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("T")]), _vm._v("en minutes after John Runyon began his newspaper deliveries, he knew he was being followed.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("And he knew why. Or thought he did.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("He grabbed a rolled-up paper from the canvas bag slung across the handlebars of his bike and flung it across the still-brown Bermuda grass of the Portillo yard. On Saturdays, the paper was pretty light. It landed just short of the welcome mat. A hand at the window waved. Everyone knew John even if they didn’t know his name. The Runyons were the only blacks in town.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The sharp dry air smelled of tumbleweeds and dust. The sun was unpinning the dark rim of the sky.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("John patted the pocket of his jeans to be sure the packet was still there.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("It was.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The pickup truck was still there, too, a block behind him, no lights. In the mirror clamped to his bike’s scarred handlebars John could make out its dark hulk, hovering. Just some drunk in a beat-up truck trying to get home? Or should he ride up a driveway and hammer on someone’s front door?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Stucco houses the color of old clay lined the next street. He chucked a paper dead center on a doorstep, then glanced at the mirror. The pickup hadn’t followed. Yet.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("John unrolled a newspaper, took something from his pocket, wadded it up, and placed it on a headline about forty-two Mexican men arrested crossing the border near El Paso, Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Which of his customers did not get up early? His gaze skipped past a wind-blown geranium in a chipped planter. The woman there was fairly new in town. Once, when he went to collect, he’d noticed a few unopened papers in her living room. Maybe she didn’t get around to reading every issue. Maybe he could make up some story, take her another paper and ask for this one back.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The paper hit the ground with a hollow sound a dozen feet short of the front steps. Bad throw, but he didn’t want to call attention to it, so he pedaled on, slinging papers as the bike’s canvas pouch grew lighter.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The sky brightened, the corners got easier to turn. The pickup was nowhere in sight. Maybe he was silly to get so spooked. He pedaled toward the last street of his route.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Turning the corner, he jammed on the brakes. Wheels skidding, he tried to turn the bike back, but it jackknifed.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The pickup was sideways across the empty road.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Two men uncoiled from the fender they had been leaning against and moved toward him.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330564e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429936354_fm01.vue
// module id = 66
// module chunks = 0